import { isAssignableExpressionNull } from '../../../../../expressions/datatype/isAssignableExpressionNull.ts';
import { type IReference } from '../../../../../expressions/references/IReference.ts';
import { ReferenceSchema } from '../../../../../expressions/validation/ReferenceSchema.ts';
import { type IBaseWidget } from '../../../../IBaseWidget.ts';

export interface IConfirmableConfig {
  confirmation?: IReference | null;
}

export interface IConfirmableWidget extends IBaseWidget, IConfirmableConfig {}

export function isConfirmableWidget(
  widget: IBaseWidget,
): widget is IConfirmableWidget {
  return widget && 'confirmation' in widget;
}

export const ConfirmationConfigSchema = ReferenceSchema.label('Conferma')
  .nullable()
  .when(['defaultValue'], ([defaultValue], schema) =>
    isAssignableExpressionNull(defaultValue)
      ? schema.enabled(false)
      : schema.enabled(true),
  );
